import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../components/store/Store';
import SettingsInputContainer from '../../../components/SettingsInputContainer';
import Container from '../../../components/Container';
import TextInput from '../../../components/forms/TextInput';
import CheckboxInput from '../../../components/forms/CheckboxInput';

export const WebpageEKulturIntegrationsSettings: FC = () => {
  const { t } = useTranslation('components');
  const { state } = useStore();
  const isSuperAdmin = state.currentUser?.user?.is_super_admin;

  return (
    <>
      <SettingsInputContainer title={t(`Settings.WebpageSettings.WebpageEKulturIntegrationsSettings.digitaltMuseum`)}>
        <Container left fullWidth>
          <Container column left>
            <Typography variant='subtitle2'>
              {t(`Settings.WebpageSettings.WebpageEKulturIntegrationsSettings.dmOwners`)}
            </Typography>
            <TextInput path='content.settings.dmOwners' defaultValue='' label='' />
          </Container>
        </Container>
        {isSuperAdmin && (
          <Container column left sx={{ width: '100%' }}>
            <div className='superadmin' style={{ backgroundColor: '#fbe6ff', padding: '1em', width: '100%' }}>
              <CheckboxInput
                fullWidth={false}
                path='content.settings.disableDMmapPin'
                label={t('Settings.WebpageSettings.WebpageIconsSettings.disableDMmapPin')}
              />
              <CheckboxInput
                fullWidth={false}
                path='content.settings.dmIncludedInSiteSearch'
                label={t('Settings.WebpageSettings.WebpageEKulturIntegrationsSettings.dmIncludedInSiteSearch')}
              />
              <CheckboxInput
                fullWidth={false}
                path='content.settings.dmIntegratedView'
                label={t('Settings.WebpageSettings.WebpageEKulturIntegrationsSettings.dmIntegratedView')}
              />
              <Container fullWidth left column mt={2}>
                <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
                  Søkebegrensninger (hvis annet enn eierkoder)
                </Typography>
                <Container fullWidth left>
                  <Typography variant='body1'>{t('DMFilterSearch.FolderIdTitleLabel')}</Typography>
                </Container>
                <Container fullWidth>
                  <TextInput path='content.settings.dmFolderuuid' defaultValue='' label='' />
                </Container>
                <Container fullWidth left>
                  <Typography variant='body1'>{t('DMFilterSearch.KulturNavTitleLabel')}</Typography>
                </Container>
                <Container fullWidth>
                  <TextInput path='content.settings.dmKulturnavuuid' defaultValue='' label='' />
                </Container>
              </Container>
            </div>
          </Container>
        )}
      </SettingsInputContainer>

      <SettingsInputContainer title={t(`Settings.WebpageSettings.WebpageEKulturIntegrationsSettings.kulturPunkt`)}>
        <Container left fullWidth>
          <Container column left>
            <Typography variant='subtitle2'>
              {t(`Settings.WebpageSettings.WebpageEKulturIntegrationsSettings.kulturpunktOwnerID`)}
            </Typography>
            <TextInput path='content.settings.kulturpunktOwnerID_v3' defaultValue='' label='' />
          </Container>
        </Container>
        {isSuperAdmin && (
          <Container column left sx={{ width: '100%' }}>
            <div className='superadmin' style={{ backgroundColor: '#fbe6ff', padding: '1em', width: '100%' }}>
              <CheckboxInput
                fullWidth={false}
                path='content.settings.disableKPmapPin'
                label={t('Settings.WebpageSettings.WebpageIconsSettings.disableKPmapPin')}
              />
              <CheckboxInput
                fullWidth={false}
                path='content.settings.kpComplete'
                label={t('Settings.WebpageSettings.WebpageEKulturIntegrationsSettings.kpComplete')}
              />
              <CheckboxInput
                fullWidth={false}
                path='content.settings.kulturpunktIncludedInSiteSearch'
                label={t('Settings.WebpageSettings.WebpageEKulturIntegrationsSettings.kulturpunktIncludedInSiteSearch')}
              />
            </div>
          </Container>
        )}
      </SettingsInputContainer>
    </>
  );
};

export default WebpageEKulturIntegrationsSettings;
